import { ISensor } from "../interfaces/ISensor";
import { IDB } from "./IDB";
import { TTable } from "./TTable";

export class Sensor {
	private readonly idb = new IDB<ISensor>();
	private readonly tableName: TTable = "sensor";

	public async put(item: ISensor): Promise<void> {
		await this.idb.putValue(this.tableName, item);
	}

	public async update(key: string, data: ISensor): Promise<void> {
		const sensor = await this.get(key) || { id: key };

		await this.idb.putValue(this.tableName, { ...sensor, ...data });
	}

	public async get(key: string): Promise<ISensor> {
		return await this.idb.getValue(this.tableName, key);
	}

	public async getAll(): Promise<ISensor[]> {
		return await this.idb.getAll(this.tableName);
	}

	public async delete(key: string): Promise<void> {
		await this.idb.deleteValue(this.tableName, key);
	}

	public static buildKey(shipmentId: string, deviceId: string, sensorDBKey: string, view: string, orderId: string): string {
	  if (view && orderId) {
      return [shipmentId, deviceId, view, orderId, sensorDBKey].join("#");
    } else {
      return [shipmentId, deviceId, sensorDBKey].join("#");
    }

	}

	public async clearObjectStore(): Promise<void> {
		await this.idb.clearObjectStore(this.tableName);
	}
}
